<template>
  <div class="AutobahnAppNoticeContainer" v-if="display">
    <div class="ContentContainer">
      <p class="displayflex flexbetween colorDarkBlue fontsize20">
        <b>Wichtige Information!</b>
        <SVGIcon
          @click.native="close"
          name="close"
          class="selfAlignCenter cursor-pointer"
          size="small"
        />
      </p>
      <div class="page">
        <p class="colorDarkGrey">
          Seit dem 01. Januar 2021 haben die Bundesländer und damit auch
          <a href="https://mobil.hessen.de/" target="_blank"
            ><b class="colorDarkBlue">Hessen Mobil</b></a
          >, die Autobahnaufgaben an die Autobahn GmbH des Bundes abgegeben, die
          seitdem für das gesamte deutsche Autobahnnetz verantwortlich ist.
        </p>
        <p class="colorDarkBlue">
          Zum 01. Januar 2022 werden auf dieser Seite daher nicht mehr die
          bekannten Inhalte zur Verfügung stehen. Hessen Mobil wird ab dem 2.
          Quartal 2022 einen Verkehrsservice auf Landesebene an dieser Stelle
          anbieten.
        </p>
        <p>
          Für das gesamte deutsche Autobahnnetz bietet die Autobahn GmbH mit der
          <b>Autobahn App</b> einen eigenen bundesweiten Verkehrsservice.
          Persönliche Routen checken, E-Ladesäulen finden oder auf über 1.000
          Live-Cams im Autobahnnetz zugreifen – diese und viele weitere Services
          vereint die Autobahn App der Autobahn GmbH. Nutzen Sie das neue
          Angebot unter
          <a href="https://www.autobahn.de/app" target="_blank"
            >autobahn.de/app</a
          >.
        </p>
        <p class="colorDarkGrey">
          Informationen rund um den Verkehr auf Landesebene finden Sie unter
          <a href="https://mobil.hessen.de/" target="_blank">mobil.hessen.de</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutobahnAppNotice",
  data: function () {
    return {
      display: true,
    };
  },
  methods: {
    close() {
      this.display = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.AutobahnAppNoticeContainer {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  z-index: 2000;
  background-color: rgba(232, 232, 232, 0.65);

  -webkit-transform: translate3d(0, 0, 0);
  font-size: 16px;
}

.ContentContainer {
  position: absolute;
  width: 600px;
  top: 250px;
  left: calc(50% + 40px);
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 10px;
  padding: 20px 80px;
  overflow-y: auto;

  max-height: calc(100vh - 160px);
  transform: translate(-50%, 0);
  top: 0;
}
@media (max-width: 768px) {
  .ContentContainer {
    left: 50%;
    top: 50%;
    width: 100%;
    height: fit-content;
    min-height: 100%;
    padding: 60px 20px 20px 20px;
    border-radius: 0;

    transform: translate(-50%, -50%);
    max-height: calc(100vh - 60px);
  }
}

@media (max-width: 768px) {
  .ContentContainer {
    padding: 25px 10px 50px 10px;
  }
}

.ArrowContainer {
  position: absolute;
  font-size: 18px;
  line-height: 20px;
}

.benachrichtigungBeispiel {
  box-shadow: 3px 3px 3px 1px #9ba0a4;
}

.page {
  height: calc(100% - 30px);
  overflow-y: auto;
}

#mehrHessenMobilInfo {
  width: 700px;
}
</style>
